import {styled, clsx} from 'external/material'
import {Link, useMemo} from 'external/react'

import useTranslations from 'hooks/translations'
import { centerVertically } from 'utils/style'

import {viewerGuard, subdomainLink} from 'utils/url'
import {logLessonAccess} from 'utils/lesson'
import useSession from 'hooks/session'
import useProfile from 'hooks/profile'


const StyledDashboardActivityItemLink = styled('div')(dashboardActivityItemLinkStyles)

export default function DashboardActivityItemLink(props) {

    const {navigation} = useSession()
    const {translate, language} = useTranslations()
    const {locked} = useProfile()
    const {hasEpl, type, clique: groupId} = props
    
    const section = useMemo(()=> parseSection(type), [type])

    const link = !locked && !hasEpl && section && section != 'lesson' && navigation.section.link({pageName: 'my-courses', groupId, section})
    
    return(<StyledDashboardActivityItemLink className={clsx(type, {hidden: !hasEpl && !link})}>
            {(hasEpl && !locked) && <a
                    className='link'
                    onClick={logLessonAccess('online', {...props, id: props.lesson})}
                      {...viewerGuard({
                        target: "_blank",
                        href: subdomainLink('preview', '#',  language, 'lesson', props.lesson)
                    })}
                >{translate('view')}</a>
            }
            {(!hasEpl || locked) && <Link className="link" to={link}>{translate('view')}</Link>}
        </StyledDashboardActivityItemLink>
   )
}

function parseSection(type) {
    switch (type) {
       case 'homework': return 'homework'
       case 'schedule': return 'lesson'
       case 'uploaded': return 'lesson'
       case 'assignment': return 'assessment'
       default: return false
    }
}

function dashboardActivityItemLinkStyles(){
    return {
        flexShrink: 0,
        flexGrow: 1,
        padding: '8px',
        ...centerVertically,
        textAlign: 'center',
        borderRadius: 10,
        cursor: 'pointer',
        backgroundColor: '#639fe4',
        '&.hidden': {
            visibility: 'hidden'
        },
        '& .link': {
            textDecoration: 'none',
            color: '#fff',
            fontSize: '11pt',
        },
        '&.comment': {
            backgroundColor: '#848b92',
            cursor: 'default'

        }
    }
}